import React from "react";
import { Skeleton } from "antd";
import MY_DEVICES from "../constants";

const SkeletonGrid: React.FC = () => (
  <div className="my-devices-grid">
    {Array.from({ length: MY_DEVICES.SKELETON_COUNT }).map((_, i) => (
      <div key={i} className="my-devices-skeleton-card">
        <Skeleton active avatar={{ shape: "square" }} paragraph={{ rows: 3 }} />
      </div>
    ))}
  </div>
);

export default SkeletonGrid;
